/*
 * Quick Add AJAX interceptor
 * Adds the product to cart via AJAX from the Quick View modal instead of
 * doing a native form submit that navigates to /cart. Runs in the capture
 * phase so it wins over the theme's product-form handler and native submit.
 */
(function () {
  function updateCartCount() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('q:cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }

  function closeModal(form) {
    var custom = form.closest('quick-add-modal');
    if (custom && typeof custom.hide === 'function') {
      custom.hide(true);
      return;
    }
    var wrap = form.closest('.quick-add-modal');
    if (wrap) wrap.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.closest('.quick-add-modal')) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      // Take over: no native submit, no theme handler, no /cart navigation.
      evt.preventDefault();
      evt.stopImmediatePropagation();

      var submitBtn = form.querySelector('[type="submit"], [name="add"]');
      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
      }

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      var cartDrawer = document.querySelector('cart-drawer');
      var body = new FormData(form);

      // Se piden las secciones del cajon en el mismo POST. Sin esto el
      // carrito se llenaba (cart.js decia 1) pero el cajon seguia con
      // class="drawer is-empty" y al abrir la bolsa se veia vacio hasta
      // recargar: este interceptor corta el handler de Dawn con
      // stopImmediatePropagation y Dawn es quien repinta el cajon.
      // Reportado por Daniela 2026-09-30.
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        body.append(
          'sections',
          cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
        );
        body.append('sections_url', window.location.pathname);
        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(document.activeElement);
        }
      }

      fetch(addUrl, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: body,
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response && response.status && response.status >= 400) return; // add failed
          // Primero se cierra el quick add, luego se pinta y abre el cajon:
          // si no, los dos pelean por el overflow-hidden del body.
          closeModal(form);
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && response.sections) {
            cartDrawer.renderContents(response);
          } else {
            updateCartCount();
          }
        })
        .catch(function (e) { console.error('Quick add failed', e); })
        .finally(function () {
          if (submitBtn) {
            submitBtn.removeAttribute('aria-disabled');
            submitBtn.classList.remove('loading');
          }
        });
    },
    true // capture phase
  );
})();
